import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../components/Button';
import Dialog from '../../../components/Dialog';

const ProjectWizardCancelDialog = ({
  visible,
  onDismiss,
  onDiscard,
  onSaveDraft,
  onPublish,
  isSavingDraft,
  isPublishing,
}) => (
  <Dialog
    title="Unsaved changes"
    visible={visible}
    onCancel={onDismiss}
    footer={
      <div className="cluster-2">
        <Button data-testid="button-cancel-discard" onClick={onDiscard}>
          Discard and exit edit mode
        </Button>
        <Button
          data-testid="button-cancel-save-draft"
          loading={isSavingDraft}
          onClick={onSaveDraft}
        >
          Save draft
        </Button>
      </div>
    }
  >
    <p className="m-0 text-sm text-neutral-300 dark:text-neutral-300">
      You have unsaved changes in this step. Save them as a draft, publish them
      to the live project, or discard them and return to view-only mode.
    </p>
  </Dialog>
);

ProjectWizardCancelDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onSaveDraft: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  isSavingDraft: PropTypes.bool,
  isPublishing: PropTypes.bool,
};

ProjectWizardCancelDialog.defaultProps = {
  isSavingDraft: false,
  isPublishing: false,
};

export default ProjectWizardCancelDialog;
